export const mutations = {
  SET_TASK_BOARDS: (state, boards) => {
    state.boards = boards;
  },
  ADD_TASK_BOARD: (state, board) => {
    state.boards.push(board);
  },
  UPDATE_TASK_BOARD: (state, board) => {
    const index = state.boards.findIndex(b => b.id === board.id);
    if (index > -1) state.boards.splice(index, 1, board);
  },
  REMOVE_TASK_BOARD: (state, id) => {
    state.boards = state.boards.filter(b => b.id !== id);
  },
  SET_TASKS: (state, tasks) => {
    state.tasks = tasks;
  },
  ADD_TASK: (state, task) => {
    state.tasks.push(task);
  },
  UPDATE_TASK: (state, task) => {
    const index = state.tasks.findIndex(t => t.id === task.id);
    if (index > -1) state.tasks.splice(index, 1, task);
    else state.tasks.push(task);
  },
  REMOVE_TASK: (state, id) => {
    state.tasks = state.tasks.filter(t => t.id !== id);
  },
};
